import "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";

interface FeatureCategory {
  title: string;
  items: any[]; // can refine later
}

interface FeatureItemHeaderProps {
  featureItems: FeatureCategory[]; // categories in current feature set
  currentIndex: number; // controlled index from parent
  onNavigate: (direction: "left" | "right") => void; // parent handles wrap + set switching
}

const FeatureitemheaderComponent: React.FC<FeatureItemHeaderProps> = ({
  featureItems,
  currentIndex,
  onNavigate,
}) => {
  const getPrevIndex = (index: number) =>
    index === 0 ? featureItems.length - 1 : index - 1;
  const getNextIndex = (index: number) =>
    index === featureItems.length - 1 ? 0 : index + 1;

  return (
    <div className="relative w-full px-2 sm:px-4 md:px-0">
      {/* Mobile layout - stacked */}
      <div className="block sm:hidden">
        {/* Navigation buttons row */}
        <div className="flex justify-between items-center mb-4">
          <button
            className="flex items-center gap-1 text-white hover:text-sow-darkGold transition-colors touch-manipulation"
            onClick={() => onNavigate("left")}
          >
            <FontAwesomeIcon icon={faChevronLeft as any} className="w-4 h-4" />
            <span className="text-sm font-medium hammer uppercase truncate max-w-[80px]">
              {featureItems.length > 0 &&
                featureItems[getPrevIndex(currentIndex)]?.title}
            </span>
          </button>

          <button
            className="flex items-center gap-1 text-white hover:text-sow-darkGold transition-colors touch-manipulation"
            onClick={() => onNavigate("right")}
          >
            <span className="text-sm font-medium hammer uppercase truncate max-w-[80px]">
              {featureItems.length > 0 &&
                featureItems[getNextIndex(currentIndex)]?.title}
            </span>
            <FontAwesomeIcon icon={faChevronRight as any} className="w-4 h-4" />
          </button>
        </div>

        {/* Center title for mobile */}
        <div className="text-center">
          <h1 className="text-2xl hammer font-bold text-sow-gold uppercase leading-tight">
            <span className="flex flex-col items-center">
              {(() => {
                const words =
                  featureItems[currentIndex]?.title?.split(" ") || [];
                if (words.length === 3) {
                  return (
                    <>
                      <span>{words.slice(0, 2).join(" ")}</span>
                      <span>{words[2]}</span>
                    </>
                  );
                } else if (words.length > 3) {
                  return (
                    <>
                      <span>{words.slice(0, 2).join(" ")}</span>
                      <span>{words.slice(2).join(" ")}</span>
                    </>
                  );
                } else {
                  return <span>{words.join(" ")}</span>;
                }
              })()}
            </span>
          </h1>
        </div>
      </div>

      {/* Desktop/Tablet layout - grid */}
      <div className="hidden sm:grid grid-cols-3 items-center gap-2 md:gap-4 w-full">
        {/* Left navigation */}
        <div className="flex justify-start">
          <h3
            className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl hammer font-semibold cursor-pointer hover:text-sow-darkGold transition-colors flex items-center gap-1 md:gap-2 text-white uppercase touch-manipulation"
            onClick={() => onNavigate("left")}
          >
            <FontAwesomeIcon
              icon={faChevronLeft as any}
              className="w-3 h-3 sm:w-4 sm:h-4"
            />
            <span className="whitespace-nowrap truncate max-w-[120px] sm:max-w-[150px] md:max-w-none">
              {featureItems.length > 0 &&
                featureItems[getPrevIndex(currentIndex)]?.title}
            </span>
          </h3>
        </div>

        {/* Center title - always perfectly centered */}
        <div className="flex justify-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl hammer font-bold text-center text-sow-gold uppercase leading-tight">
            <span className="flex flex-col items-center">
              {(() => {
                const words =
                  featureItems[currentIndex]?.title?.split(" ") || [];
                if (words.length === 3) {
                  return (
                    <>
                      <span>{words.slice(0, 2).join(" ")}</span>
                      <span>{words[2]}</span>
                    </>
                  );
                } else if (words.length > 3) {
                  return (
                    <>
                      <span>{words.slice(0, 2).join(" ")}</span>
                      <span>{words.slice(2).join(" ")}</span>
                    </>
                  );
                } else {
                  return <span>{words.join(" ")}</span>;
                }
              })()}
            </span>
          </h1>
        </div>

        {/* Right navigation */}
        <div className="flex justify-end">
          <h3
            className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl hammer font-semibold cursor-pointer hover:text-sow-darkGold transition-colors flex items-center gap-1 md:gap-2 text-white uppercase touch-manipulation"
            onClick={() => onNavigate("right")}
          >
            <span className="whitespace-nowrap truncate max-w-[120px] sm:max-w-[150px] md:max-w-none">
              {featureItems.length > 0 &&
                featureItems[getNextIndex(currentIndex)]?.title}
            </span>
            <FontAwesomeIcon
              icon={faChevronRight as any}
              className="w-3 h-3 sm:w-4 sm:h-4"
            />
          </h3>
        </div>
      </div>
    </div>
  );
};

export default FeatureitemheaderComponent;
